import React from "react";
import PropTypes from "prop-types";
import ReactTableForm from "../../../../components/Common/ReactTableForm";
import DynamicFormMultipleFilter from "../../../../components/forms/DynamicFormMultipleFilter";
import queryString from "query-string";
import PlanOverviewBreadcrumb from "./common/PlanOverviewBreadcrumb";
import styled from "styled-components";
import CustomSelect from "../../../../components/Common/CustomSelect";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { showInfoMessage } from "../../../../helpers/utils";
import SweetAlert from "react-bootstrap-sweetalert";
import EditCustomPlanModal from "./common/EditCustomPlanModal";
import ProjectProfitWidgets from "./common/ProjectProfitWidgets";

const PlansOverview = ({
  loading,
  data,
  profitFilterData,
  handleDateRangeChange,
  handleChangeNestingTable,
  filter_data,
  selectedGroupTable,
  nesting,
  history,
  OverviewAddNewRow,
  RemoveOverviewRow,
  AddCustomProfit,
  DeleteCustomProfit,
  editCustomProfit,
  closeEditCustomProfit,
  updateCustomProfit,
  updatePlanGroup,
  getCustomProfitByDays,
  customProfitByDayData,
  customProfitByDayLoader,
  permissions,
  setCustomProfitByDays,
  updateCustomProfitByDays,
  addCustomProfitByDays,
  handleTableChange,
  planStatus
}) => {
  const [newData, setNewData] = React.useState([]);
  const [deleteAlert, setDeleteAlert] = React.useState(null);
  const [customPlanModal, setCustomPlanModal] = React.useState({
    status: false,
    data: null,
  });

  React.useEffect(() => {
    if (nesting) {
      setNewData([]);
    }
  }, [nesting]);

  const defaultRow = {
    cost: 0,
    group_name: "Name...",
    income: 0,
    account_manager: "Manager",
    payout: 0,
    percent: "0",
    plan: 0,
    corrected_plan: 0,
    profit: 0,
    profit_with_cashback: 0,
    voucher: 0,
    fact_cost: 0,
  };

  const TABLE = {
    defaultStyle: {
      textAlign: "center",
      width: "auto",
      verticalAlign: "middle",
    },
    columnsGroup: [
      {
        Header: "Offer",
        src: "offer",
        sort: true,
        accessor: row => (
          <span
            className={!row?.is_sum ? "text-primary" : ""}
            data-toggle="tooltip"
            title={renderOfferName(row)?.title}
          >
            {renderOfferName(row)?.name}
          </span>
        ),
      },
      {
        Header: "Project Manager",
        src: "manager",
        accessor: "manager",
        sort: true,
      },
      {
        Header: "Plan",
        src: "plan",
        // accessor: "plan",
        sort: true,
        accessor: row => (row.plan === "$None" ? "$0" : row.plan),
      },
      {
        Header: "Corrected plan",
        src: "corrected_plan",
        // accessor: "corrected_plan",
        sort: true,
        accessor: row =>
          row.corrected_plan === "$None" ? "$0" : row.corrected_plan,
      },
      {
        Header: "Income",
        src: "income",
        accessor: "income",
        sort: true,
      },
      {
        Header: "Cost",
        src: "cost",
        accessor: "cost",
        sort: true,
      },
      {
        Header: "Profit",
        accessor: "profit",
        src: "profit",
        sort: true,
      },
      {
        Header: "Profit (with cashback)",
        accessor: "profit_with_cashback",
        src: "profit_with_cashback",
        sort: true,
      },
      {
        Header: "Percent",
        accessor: "percent",
        src: "percent",
        sort: true,
      },
      // {
      //   Header: "Payout",
      //   accessor: "payout",
      //   sort: true,
      // },
    ],
    columns: [
      {
        Header: nesting ? "Offer" : "Group",
        src: nesting ? "name" : "group_name",
        sort: true,
        style: {
          maxWidth: 180,
        },
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit ? (
                <AvForm>
                  <AvField
                    name="name"
                    type="text"
                    placeholder="Name..."
                    defaultValue={row?.is_custom ? row?.name : row?.group_name}
                    onChange={e =>
                      handleChangeForm(row?.edit_id, "name", e.target.value)
                    }
                  />
                </AvForm>
              ) : (
                <span
                  className={
                    !row?.is_sum && !row?.can_edit && !row?.is_custom
                      ? "text-primary"
                      : ""
                  }
                  data-toggle="tooltip"
                  title={renderOfferName(row)?.title}
                  onClick={() =>
                    !nesting &&
                    !row?.can_edit &&
                    !row?.is_custom &&
                    handleChangeNestingTable(true, { name: row.group_name })
                  }
                >
                  {row?.id && row?.name}
                  {nesting ? renderOfferName(row)?.name : row.group_name}
                </span>
              )}
            </>
          );
        },
      },
      {
        Header: "Project Manager",
        src: "manager",
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit && row?.is_custom ? (
                <AvForm>
                  <CustomSelect
                    name="account_manager"
                    options={filter_data.all_account_managers}
                    placeholder="Manager..."
                    defaultValue={
                      row?.manager_id
                        ? { value: row?.manager_id, label: row?.manager }
                        : ""
                    }
                    onChange={a =>
                      handleChangeForm(row?.edit_id, "account_manager", a)
                    }
                    classNamePrefix="select2-selection"
                  />
                </AvForm>
              ) : (
                row.manager
              )}
            </>
          );
        },
        style: {
          minWidth: 180,
        },
        sort: true,
      },
      {
        Header: "Plan",
        src: 'plan',
        sort: true,
        style: {
          textAlign: "center",
          maxWidth: 180,
        },
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit ? (
                <AvForm>
                  <AvField
                    name="plan"
                    type="number"
                    placeholder="Planned sum..."
                    defaultValue={row?.plan}
                    onChange={e =>
                      handleChangeForm(row?.edit_id, "plan", e.target.value)
                    }
                  />
                </AvForm>
              ) : row.plan === "$None" ? (
                "$0"
              ) : (
                row.plan
              )}
            </>
          );
        },
      },
      {
        Header: "Corrected plan",
        src: 'corrected_plan',
        sort: true,
        style: {
          textAlign: "center",
          maxWidth: 180,
        },
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit ? (
                <AvForm>
                  <AvField
                    name="corrected_plan"
                    type="number"
                    placeholder="Corrected plan..."
                    defaultValue={row?.corrected_plan}
                    onChange={e =>
                      handleChangeForm(
                        row?.edit_id,
                        "corrected_plan",
                        e.target.value
                      )
                    }
                  />
                </AvForm>
              ) : row.corrected_plan === "$None" ? (
                "$0"
              ) : (
                row.corrected_plan
              )}
            </>
          );
        },
      },
      {
        Header: "Income",
        src: 'payment',
        style: {
          textAlign: "center",
          maxWidth: 180,
        },
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit && row?.is_custom ? (
                <AvForm>
                  <AvField
                    name="payment"
                    type="number"
                    placeholder="Income..."
                    defaultValue={row?.payment}
                    onChange={e =>
                      handleChangeForm(row?.edit_id, "payment", e.target.value)
                    }
                  />
                </AvForm>
              ) : (
                row?.income
              )}
            </>
          );
        },
        sort: true,
      },
      {
        Header: "Cost",
        src: 'spend',
        style: {
          textAlign: "center",
          maxWidth: 180,
        },
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit && row?.is_custom ? (
                <AvForm>
                  <AvField
                    name="spend"
                    type="number"
                    placeholder="Cost..."
                    defaultValue={row?.spend}
                    onChange={e =>
                      handleChangeForm(row?.edit_id, "spend", e.target.value)
                    }
                  />
                </AvForm>
              ) : (
                row?.cost
              )}
            </>
          );
        },
        sort: true,
      },
      {
        Header: "Voucher",
        accessor: "voucher",
        src: 'voucher',
        style: {
          maxWidth: 120,
          textAlign: "center",
        },
        sort: true,
      },
      {
        Header: "Fact cost",
        accessor: "fact_cost",
        src: 'fact_cost',
        style: {
          maxWidth: 120,
          textAlign: "center",
        },
        sort: true,
      },
      {
        Header: "Cashback",
        accessor_id: "cashback",
        src: 'cashback',
        style: {
          maxWidth: 180,
          textAlign: "center",
        },
        accessor: (row, i) => {
          return (
            <>
              {row.can_edit ? (
                <AvForm>
                  <AvField
                    name="cashback"
                    type="number"
                    placeholder="Cashback.."
                    defaultValue={row?.cashback}
                    onChange={e =>
                      handleChangeForm(row?.edit_id, "cashback", e.target.value)
                    }
                  />
                </AvForm>
              ) : row.cashback === "$None" ? (
                "$0"
              ) : (
                <div>{row.cashback}</div>
              )}
            </>
          );
        },
      },
      {
        Header: "Profit",
        accessor: "profit",
        src: 'profit',
        style: {
          maxWidth: 180,
          textAlign: "center",
        },
        sort: true,
      },
      {
        Header: "Profit (with cashback)",
        accessor: "profit_with_cashback",
        src: 'profit_with_cashback',
        style: {
          maxWidth: 120,
          textAlign: "center",
        },
        sort: true,
      },
      {
        Header: "Percent",
        // accessor: "percent",
        src: 'percent',
        accessor: (row, i) => (
          <div
            style={{
              alignItems: "center",
              verticalAlign: "middle",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>{row.percent}</span>
            <StyledAdd
              className={`${!row?.is_sum && !nesting ? "" : "d-none"
                } add-table-new-row`}
              style={{
                display:
                  permissions["is_admin"] ||
                    permissions["is_head_of_accountmanager"] ||
                    permissions["is_accountmanager"] 
                    ? ""
                    : "none",
              }}
            >
              <div
                className={`${!row?.can_edit && row?.id ? "" : "d-none"}`}
                onClick={
                  row?.can_edit
                    ? ""
                    : row?.is_custom
                      ? () => handleChangeEditCustomPlan(row)
                      : () => handleEditCustomProfit(i, row?.is_custom, row?.id)
                }
              >
                {/* row?.can_edit && row?.is_custom
                    ? () => handleUpdateCustomProfit(i)
                    : () => handleEditCustomProfit(i) */}
                <span>
                  <i className="mdi mdi-lead-pencil" />
                </span>
              </div>
              <div
                className={`${row?.can_edit ? "" : row?.is_custom ? "" : "d-none"
                  }`}
                onClick={
                  row?.id && row?.can_edit
                    ? () => handleCloseEdit(i)
                    : () => handleRemoveCustomRow(i, row?.id, row)
                }
              >
                <span>
                  {row?.id && row?.can_edit ? (
                    <i className="mdi mdi-close" />
                  ) : (
                    <i className="bx bx-minus" />
                  )}
                </span>
              </div>
              <div
                className={!row?.can_edit ? "" : "d-none"}
                onClick={() => HandleAddNewRow(i, row?.can_edit)}
              >
                <span>
                  <i className="bx bx-plus" />
                </span>
              </div>
            </StyledAdd>
          </div>
        ),
        style: {
          maxWidth: 140,
          textAlign: "center",
        },
        sort: true,
      },
    ],
  };

  const handleChangeEditCustomPlan = data => {
    setCustomPlanModal({
      status: true,
      data: {
        ...data,
        date: profitFilterData.start_date,
      },
    });
  };

  const handleCloseEditCustomPlan = () => {
    setCustomPlanModal({ status: false, data: null });
  };

  const handleChangeDeleteAlert = data => {
    setDeleteAlert(data);
  };

  const onClickDelete = data => {
    handleChangeDeleteAlert({
      // eslint-disable-next-line react/prop-types
      title: `Delete "${data?.name}"!`,
      onConfirm: () => {
        try {
          // eslint-disable-next-line react/prop-types
          DeleteCustomProfit(data?.id);
          setNewData([]);
          handleChangeDeleteAlert(null);
        } catch (e) {
          handleChangeDeleteAlert(null);
        }
      },
    });
  };

  const handleChangeForm = (i, field, data) => {
    let currentNewData = newData;
    currentNewData[0][field] = data;
    setNewData(currentNewData);
  };

  const handleUpdateCustomProfit = () => {
    try {
      let params = {
        ...newData[0],
      };
      params["account_manager"] = params["account_manager"]?.value;
      if (params?.is_custom) {
        if (!params?.payment) {
          params["payment"] = 0;
        }
        if (!params?.spend) {
          params["spend"] = 0;
        }
        if (params?.cashback) {
          params["cashback_type"] = "custom";
        }
        params["profit"] = (params?.payment - params?.spend).toFixed(2);
        updateCustomProfit(params);
      } else {
        let groupUpdateData = {
          name: params?.name || params?.group_name,
          planned_sum: params?.plan,
          corrected_plan: params?.corrected_plan,
        };

        if (params?.cashback) {
          groupUpdateData["cashback"] = params?.cashback;
          groupUpdateData["cashback_type"] = "calculated";
          groupUpdateData["cashback_id"] = params?.cashback_id;
          groupUpdateData["id"] = params?.id;
        }
        updatePlanGroup(params.id, groupUpdateData);
      }
      setNewData([]);
    } catch (e) {
      // console.log(e);
    }
  };

  const handleCloseEdit = i => {
    closeEditCustomProfit(i);
    setNewData([]);
  };

  const handleEditCustomProfit = (i, custom, id) => {
    if (newData.length < 1) {
      editCustomProfit(i);
      setNewData([
        {
          ...data.results[i],
          custom_edit: custom,
        },
      ]);
    } else {
      showInfoMessage("You already have an active field");
    }
  };

  const handleRemoveCustomRow = (i, id, row) => {
    if (id) {
      onClickDelete({ id: id, name: row?.name || row?.group_name });
    } else {
      setNewData([]);
      RemoveOverviewRow(i);
    }
  };

  const HandleAddNewRow = (idx, edit) => {
    if (edit) {
      if (newData.length < 1)
        return showInfoMessage("You have no one field for add");
      newData[0]["date_from"] = profitFilterData.start_date;
      newData[0]["date_to"] = profitFilterData.end_date;
      newData[0]["account_manager"] = newData[0]["account_manager"]?.value;
      if (!newData[0]?.payment) {
        newData[0]["payment"] = 0;
      }
      if (!newData[0]?.spend) {
        newData[0]["spend"] = 0;
      }
      newData[0]["profit"] = (newData[0]?.payment - newData[0]?.spend).toFixed(
        2
      );
      try {
        AddCustomProfit(idx, newData);
        setNewData([]);
      } catch (e) {
        // console.log(e);
      }
    } else {
      if (newData.length >= 1) {
        showInfoMessage("You already have an active field");
      } else {
        let newDataUpdate = newData;
        newDataUpdate.push({ edit_id: newDataUpdate.length + 1 });
        setNewData(newDataUpdate);
        const newRow = {
          ...defaultRow,
          date_from: profitFilterData.start_date,
          date_to: profitFilterData.end_date,
          profit: 0,
          edit_id: newDataUpdate.length,
          can_edit: true,
          is_custom: true,
        };
        OverviewAddNewRow(idx, newRow);
      }
    }
  };
  const renderOfferName = row => {
    let name = "";
    let title = "";
    if (row?.is_sum) {
      name = "Total";
      title = "";
    } else {
      name =
        row.offer_name?.length > 10
          ? row?.offer_name.substr(0, 10) + "..."
          : row?.offer_name;
      title = row?.offer_name;
    }
    return {
      name,
      title,
    };
  };

  const cellProps = info => {
    if (info.row.original?.is_sum) {
      return {
        style: {
          ...TABLE.defaultStyleColumns,
          fontWeight: "600",
          backgroundColor: "#91ebd2",
        },
      };
    } else {
      return {
        style: {
          ...TABLE.defaultStyleColumns,
        },
      };
    }
  };

  const handleChangeTable = (data) => {
    handleTableChange(data);
  };

  return (
    <div>
      {deleteAlert && (
        <SweetAlert
          showCancel
          confirmBtnText="Delete"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle=""
          title={deleteAlert.title}
          onCancel={() => setDeleteAlert(null)}
          onConfirm={deleteAlert.onConfirm}
        >
          <p>Are you sure want to delete this custom plan?</p>
        </SweetAlert>
      )}
      {customPlanModal.status && (
        <EditCustomPlanModal
          editData={customPlanModal.data}
          toggle={handleCloseEditCustomPlan}
          isOpen={customPlanModal.status}
          getCustomProfitByDays={getCustomProfitByDays}
          setCustomProfitByDays={setCustomProfitByDays}
          data={customProfitByDayData}
          currentMonth={profitFilterData}
          loader={customProfitByDayLoader}
          updateCustomProfitByDays={updateCustomProfitByDays}
          addCustomProfitByDays={addCustomProfitByDays}
          account_managers={filter_data.users}
          updateCustomProfit={updateCustomProfit}
          permissions={permissions}
        />
      )}

      <DynamicFormMultipleFilter
        onlyMonth
        onFiltersChange={handleDateRangeChange} // date
        selectedDate={[]}
        filtered_params={queryString.parse(history.location.search)}
        filtered_by={["offer_id", "account_manager"]}
        dateFilters={[
          {
            value: profitFilterData.start_date,
            isTitle: false,
            plug: "Date range",
            key: "date_range",
          },
        ]}
        style={{ padding: "0.5rem 0" }}
        isTitle={false}
        name="overview"
        childrenBreadCrumbs
      >
        <PlanOverviewBreadcrumb
          data={selectedGroupTable}
          onClick={handleChangeNestingTable}
        />
      </DynamicFormMultipleFilter>

      <ScrollTable>
        {/* {!loading ? ( */}
          <ReactTableForm
            loading={loading}
            columns={TABLE.columns}
            data={data.results?.data ? { results: [] } : data.results}
            onTableChange={handleChangeTable}
            getCellProps={cellInfo => cellProps(cellInfo)}
            isStriped={false}
            overflow={false}
            childNoData={planStatus === 206 ? (
              <div className="flex text-center">
                Plans with selected date range not found! <br />
                You can create it - <a href="https://crm.advaice.com/project-manager-plans/add/">here</a>
              </div>
            ) : 'There is no data to display'}
            customColorsCashback
          />
        {/* ) : (
          <div
            className="loader-for-react-table justify-content-center"
            style={{ display: "flex", padding: "45px 0" }}
          >
            <div className="spinner-border text-primary m-1" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )} */}
      </ScrollTable>
      {newData.length > 0 && (
        <div className="d-flex justify-content-end mt-4">
          {newData[0].id ? (
            <button
              type="submit"
              className="btn btn-success save-user ms-2"
              onClick={() => handleUpdateCustomProfit()}
            >
              Save changes
            </button>
          ) : (
            <button
              type="submit"
              className="btn btn-primary save-user ms-2"
              onClick={() => HandleAddNewRow(newData[0]?.id, true)}
            >
              Add custom plan
            </button>
          )}
        </div>
      )}
    </div>
  );
};

const ScrollTable = styled.div`
  min-width: 279px;
  height: 100%;
  /* overflow-y: auto; */
`;

const StyledAdd = styled.div`
  opacity: 0;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;

  div {
    color: #fff;
    background: rgba(42, 48, 66, 0.7);
    padding: 9px;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    max-width: 10px;
    max-height: 10px;
    z-index: 99;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    transition: all 0.5s ease;
    margin: 0 5px;

    span {
      display: flex;
      vertical-align: middle;
      justify-content: center;
      align-items: center;
      width: 0px;
      height: 0px;
    }

    &:hover {
      -webkit-transition: all 0.5s ease;
      -moz-transition: all 0.5s ease;
      transition: all 0.5s ease;
      background: rgba(42, 48, 66, 1);
    }
  }
`;

PlansOverview.propTypes = {
  data: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
    widget: PropTypes.object,
  }).isRequired,
  customProfitByDayData: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  profitFilterData: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  handleDateRangeChange: PropTypes.func.isRequired,
  filter_data: PropTypes.any,
  nesting: PropTypes.bool,
  handleChangeNestingTable: PropTypes.func,
  handleTableChange: PropTypes.func,
  selectedGroupTable: PropTypes.any,
  OverviewAddNewRow: PropTypes.func.isRequired,
  RemoveOverviewRow: PropTypes.func.isRequired,
  AddCustomProfit: PropTypes.func.isRequired,
  DeleteCustomProfit: PropTypes.func.isRequired,
  editCustomProfit: PropTypes.func.isRequired,
  closeEditCustomProfit: PropTypes.func.isRequired,
  updateCustomProfit: PropTypes.func.isRequired,
  updatePlanGroup: PropTypes.func.isRequired,
  getCustomProfitByDays: PropTypes.func.isRequired,
  customProfitByDayLoader: PropTypes.bool,
  setCustomProfitByDays: PropTypes.func.isRequired,
  updateCustomProfitByDays: PropTypes.func.isRequired,
  addCustomProfitByDays: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  planStatus: PropTypes.any,
};

export default PlansOverview;
